import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col q-mx-md" }
const _hoisted_3 = { class: "col q-mx-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_select = _resolveComponent("q-select")
  const _component_q_form = _resolveComponent("q-form")

  return (_openBlock(), _createBlock(_component_q_form, { ref: "form" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_q_input, {
            id: "profesion",
            modelValue: _ctx.filtro.profesion,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filtro.profesion = $event)),
            modelModifiers: { number: true },
            label: "Profesión"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_q_select, {
            clearable: "",
            filled: "",
            modelValue: _ctx.filtro.agrupacion,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filtro.agrupacion = $event)),
            "use-input": "",
            "map-options": "",
            "emit-value": "",
            "option-value": "id",
            "option-label": "descripcion",
            "stack-label": "",
            "input-debounce": "0",
            label: "Agrupación",
            options: _ctx.agrupaciones,
            behavior: "menu",
            onFilter: _ctx.filterFn
          }, null, 8, ["modelValue", "options", "onFilter"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}